import React from 'react';
import { MagazineIssueCard } from '../MagazineIssueCard/index.js';
import style from './style.scss';
export const MagazineIssueList = ({ issues }) => {
    const issueElems = issues.map((issue) => React.createElement(MagazineIssueCard, { key: issue.title + issue.coverImageUrl, issue: issue }));
    return (React.createElement("div", { className: style.container }, issueElems));
};
